<template>
    <div>
        <app-page-header></app-page-header>
        <v-container  grid-list-xl>
            
                <v-layout row wrap align-center justify-center fill-height>
                    <v-flex xs12 sm12 md12 lg12 xl12>
                        <v-form id="form_add_registration_number" ref="form" v-model="valid" lazy-validation>
                            <v-card id="form_card">
                                <v-card-title>
                                    <v-icon left>mdi-car-info</v-icon>
                                        <span class="subtitle-1 font-weight-regular application--card--title">Validacija registrske številke</span>
                                        <v-spacer></v-spacer>
                                    <v-btn icon @click="card1 = !card1">
                                        <v-icon>{{ card1 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-divider v-show="card1"></v-divider>

                                <!-- osebni podatki -->
                                <v-card-text v-show="card1">

                                    <!-- backend validation messages -->
                                    <form-validation-messages :messages="apiValidationMessages"></form-validation-messages>
                                    <form-submit-messages :messages="apiMessages" :errorMessages="apiErrorMessages"></form-submit-messages>

                                    <v-text-field 
                                        v-model="registration_number"
                                        label="Vnesite registrsko številko"
                                        required
                                        clearable
                                        :rules="registration_number_rules"
                                    ></v-text-field>

                                    <!--<v-layout row justify-center v-bind="columnBinding">
                                            <v-flex xs8 md4 align-content-center>
                                                <v-subheader class="pt-7 pl-0"><strong>Veljavnost</strong></v-subheader>
                                            </v-flex>
                                            <v-flex xs12 md4 align-content-center>
                                                <v-menu
                                                    ref="start_date_menu"
                                                    :close-on-content-click="false"
                                                    v-model="start_date_menu"
                                                    :nudge-right="40"
                                                    :return-value.sync="restriction_start_date"
                                                    
                                                    transition="scale-transition"
                                                    offset-y
                                                    
                                                    min-width="290px"
                                                    >
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field
                                                        v-on="on"
                                                            v-model="restriction_start_date_formatted"
                                                            label="Datum od"
                                                            prepend-icon="mdi-calendar-today"
                                                            readonly
                                                            clearable
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker color="secondary" @input="startDateMenuSave(restriction_start_date)" v-model="restriction_start_date" no-title scrollable locale="sl-si">
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-flex>
                                            <v-flex xs12 md4 align-content-center>
                                                <v-menu
                                                    ref="end_date_menu"
                                                    :close-on-content-click="false"
                                                    v-model="end_date_menu"
                                                    :nudge-right="40"
                                                    :return-value.sync="restriction_end_date"
                                                    
                                                    transition="scale-transition"
                                                    offset-y
                                                    
                                                    min-width="290px"
                                                    >
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field
                                                        v-on="on"
                                                            v-model="restriction_end_date_formatted"
                                                            label="Datum do"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            clearable
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker color="secondary" @input="endDateMenuSave(restriction_end_date)" v-model="restriction_end_date" no-title scrollable locale="sl-si">
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-flex>-
                                        </v-layout>-->
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-text v-show="card1" v-if="$vuetify.breakpoint.xsOnly">
                                    <v-btn block outlined style="margin-bottom:10px;" @click="submitForm()" color="success" :disabled="loading"><v-icon left>mdi-arrow-right</v-icon>{{ btnSubmitFormTitle }}</v-btn>
                                    <v-btn block outlined style="margin-bottom:10px;" @click="clearForm()" color="warning"><v-icon left>mdi-refresh</v-icon>Prekliči</v-btn>
                                </v-card-text>
                                <v-card-text v-show="card1" v-else>
                                    <v-btn @click="submitForm()" color="success" text :disabled="loading"><v-icon left>mdi-arrow-right</v-icon>{{ btnSubmitFormTitle }}</v-btn>
                                    <v-btn @click="clearForm()" color="warning" text><v-icon left>mdi-refresh</v-icon>Prekliči</v-btn>
                                </v-card-text>
                            </v-card>
                        </v-form>
                    </v-flex>
                </v-layout>

                <!-- kriterij iskanja -->
            <v-layout row wrap align-center justify-center fill-height>
                <v-flex xs12 sm12 md12 lg12 xl12>
                        <v-card>
                            <v-card-title>
                                    <span class="subtitle-1"><v-icon left>mdi-filter</v-icon> Kriterij iskanja</span>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click="card2 = !card2">
                                        <v-icon>{{ card2 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                    </v-btn>
                            </v-card-title>
                            <v-divider v-show="card2"></v-divider>
                            <v-card-text v-show="card2">
                                <!-- datumska omejitev -->
                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs8 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Datumska omejitev (od - do)</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md4 align-content-center>
                                            <!-- začetni datum -->
                                            <v-menu
                                                ref="start_date_menu"
                                                :close-on-content-click="false"
                                                v-model="start_date_menu"
                                                :nudge-right="40"
                                                :return-value.sync="restriction_start_date"
                                                
                                                transition="scale-transition"
                                                offset-y
                                                
                                                min-width="290px"
                                                >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                    v-on="on"
                                                        v-model="restriction_start_date_formatted"
                                                        label="Datum od"
                                                        prepend-icon="mdi-calendar-today"
                                                        readonly
                                                        clearable
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker color="secondary" @input="startDateMenuSave(restriction_start_date)" v-model="restriction_start_date" no-title scrollable locale="sl-si">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs12 md4 align-content-center>
                                            <!-- končni datum -->
                                            <v-menu
                                                ref="end_date_menu"
                                                :close-on-content-click="false"
                                                v-model="end_date_menu"
                                                :nudge-right="40"
                                                :return-value.sync="restriction_end_date"
                                                
                                                transition="scale-transition"
                                                offset-y
                                                
                                                min-width="290px"
                                                >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                    v-on="on"
                                                        v-model="restriction_end_date_formatted"
                                                        label="Datum do"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        clearable
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker color="secondary" @input="endDateMenuSave(restriction_end_date)" v-model="restriction_end_date" no-title scrollable locale="sl-si">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <!-- časovna omejitev -->
                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs8 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Časovna omejitev (od - do)</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md4 align-content-center>
                                            <v-menu
                                                ref="start_time_menu"
                                                v-model="start_time_menu"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                :return-value.sync="start_time"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="start_time"
                                                    label="Začetni čas"
                                                    prepend-icon="mdi-clock-outline"
                                                    readonly
                                                    v-on="on"
                                                    clearable
                                                ></v-text-field>
                                                </template>
                                                <v-time-picker
                                                color="secondary"
                                                format="24hr"
                                                v-if="start_time_menu"
                                                v-model="start_time"
                                                
                                                @click:minute="$refs.start_time_menu.save(start_time)"
                                                ></v-time-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs12 md4 align-content-center>
                                                <v-menu
                                                ref="end_time_menu"
                                                v-model="end_time_menu"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                :return-value.sync="end_time"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="end_time"
                                                    label="Končni čas"
                                                    prepend-icon="mdi-clock-outline"
                                                    readonly
                                                    v-on="on"
                                                    clearable
                                                ></v-text-field>
                                                </template>
                                                <v-time-picker
                                                color="secondary"
                                                format="24hr"
                                                v-if="end_time_menu"
                                                v-model="end_time"
                                                
                                                @click:minute="$refs.end_time_menu.save(end_time)"
                                                ></v-time-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Podjetje</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-select
                                            v-model="selected_companies"
                                            :items="companies"
                                            label="Izberi podjetje"
                                            multiple
                                            chips
                                            clearable
                                            deletable-chips
                                            prepend-icon="mdi-monitor-star"
                                            item-value="id"
                                            item-text="name"
                                            return-object
                                            dense
                                            no-data-text="Ni podatkov za prikaz"
                                        ></v-select>   
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <!-- naprava 
                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Naprava</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-select
                                            v-model="selected_devices"
                                            :items="devices"
                                            label="Izberi napravo"
                                            multiple
                                            chips
                                            clearable
                                            deletable-chips
                                            prepend-icon="mdi-monitor-star"
                                            item-value="id"
                                            item-text="name"
                                            return-object
                                            dense
                                            no-data-text="Ni podatkov za prikaz"
                                        ></v-select>   
                                        </v-flex>
                                    </v-layout>
                                </v-container> -->

                                <!-- registrska številka -->
                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Registrska številka</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-text-field
                                            v-model="registration_number"
                                            label="Vpiši registrsko številko"
                                            prepend-icon="mdi-pencil"
                                            @keyup.esc="clearRegistrationNumber"
                                            @keyup.enter="search"
                                            clearable
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-6 pl-0"><strong>Veljavne validacije</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-checkbox @change="displayResults()" class="ti" v-model="valid_validations" :label="`Prikaži samo veljavne validacije: ${checkboxValidOnlyLabel}`"></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                                
                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-6 pl-0"><strong>Pretečena veljavnost</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-checkbox @change="displayResults()" class="ti" v-model="expired" :label="`Prikaži samo pretečene validacije: ${checkboxExpiredOnlyLabel}`"></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <v-container grid-list-xl text-x-center align-center>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-6 pl-0"><strong>Prikaži samo uporabljene validacije</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-checkbox @change="displayResults()" class="ti" v-model="used" :label="`Prikaži samo uporabljene validacije: ${checkboxUsedOnlyLabel}`"></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                            </v-card-text>
                            <v-divider v-show="card2"></v-divider>
                            <span v-if="card2">
                                <v-card-text v-if="$vuetify.breakpoint.xsOnly">
                                <v-btn   @click="search()" color="secondary" dark  block outlined style=""><v-icon left>mdi-magnify</v-icon>Prikaz rezultatov&nbsp;</v-btn><br>
                                <v-btn v-if="checkApplicationPermissions(['sobec-export-registration-numbers'])"   @click="exportData()" color="secondary" dark  block outlined style=""><v-icon left>mdi-export</v-icon>Izvoz&nbsp;</v-btn>
                                </v-card-text>
                                <v-card-text v-else>
                                    <v-btn  @click="search()" color="secondary" dark text><v-icon left>mdi-magnify</v-icon>Prikaz rezultatov&nbsp;</v-btn>
                                    <v-btn v-if="checkApplicationPermissions(['sobec-export-registration-numbers'])"  @click="exportData()" color="secondary" dark text><v-icon left>mdi-export</v-icon>Izvoz&nbsp;</v-btn>
                                </v-card-text>
                            </span>
                        </v-card>
                </v-flex>
            </v-layout>

            <div style="min-height:10px;"></div>

            <registration-numbers-data-table
            :settings="dataTableSettings"
            :queryParameters="queryParameters"
            ></registration-numbers-data-table> 

            <data-table-toggle-columns
            :dataTableId="dataTableSettings.id"
            :columns="dataTableSettings.headers"
            dataTableColumnsMenuId="toggle-events-list-columns"
            ></data-table-toggle-columns>
            
        </v-container>
    </div>
</template>

<script>
import { formatDate, randomPinNumber, getCurrentDate, isMobileDevice, getUserApplicationRole, getUserApplicationPermissions, checkPermissions } from '@/helpers/utilities.js'
const FormValidationMessages = () => import('@/components/FormValidationMessages.vue')
const FormSubmitMessages = () => import('@/components/FormSubmitMessages.vue')
const RegistrationNumbersDataTable = () => import('@/components/RegistrationNumbersDataTable.vue')
const DataTableToggleColumns = () => import('@/components/DataTableToggleColumns.vue')
import { EventBus } from '@/main.js'
import { addExportToQueue } from '@/helpers/services.js'

export default {
    components: {
        FormValidationMessages,
        FormSubmitMessages,
        RegistrationNumbersDataTable,
        DataTableToggleColumns
    },

    data: () =>({
        card1: true,
        card2: false,
        valid: true,
        form:true,
        start_time:null,
        end_time: null,

        registration_number: null,
        used_registration_numbers: false,
        restriction_start_date: null,
        restriction_end_date:null,
        restriction_start_date_formatted: null,
        restriction_end_date_formatted: null,
        start_date_menu: false,
        end_date_menu:false,

        start_time_menu:false,
        end_time_menu:false,
        expired: false,
        used: false,
        valid_validations: false,

        selected_companies: [],
        companies: [],

        loading: false,
        storeUserLoading: false,
        currentDate: null,

        backendMessages: [],
        backendErrorMessages: [],
        backendValidationMessages:[],

        registration_number_rules: [v => !!v || 'Polje za vnos registrske številke je obvezno'],
        refreshCompaniesInterval: null,
        

        dataTableSettings: {
            id: 'dtRegistrationNumbers',
            title: 'Seznam registrskih številk',
            sortColumn: ['id'],
            sortDirection: ['desc'],
            progressHeight: 4,
            headers: [
                { text: "ID", value: "id", class: "text-xs-left", visibility: true },
                { text: "Registrska številka", value: "registration_number", class: "text-xs-left", visibility: true },
                { text: "Čas prihoda", value: "event_timestamp_formatted", class: "text-xs-left", visibility: true },
                { text: "Čas validacije", value: "created_at_formatted", class: "text-xs-left", visibility: true },
                { text: "Veljavnost do", value: "allowed_until_formatted", class: "text-xs-left", visibility: true },
                { text: "Prehod", value: "used", class: "text-xs-left", visibility: true },
                { text: "Čas prehoda", value: "pass_timestamp_formatted", class: "text-xs-left", visibility: true },
                { text: "Trajanje parkiranja", value: "duration", class: "text-xs-left", visibility: true },
                { text: "Podjetje", value: "company", class: "text-xs-left", visibility: true },
                { text: "Validiral", value: "user_name", class: "text-xs-left", visibility: true },
                { text: "Upravljanje", value: "action", align: "right", class: "text-xs-right", sortable: false, visibility: true},
            ],
            updateInterval: false,
            rowsPerPage: 10,
            endpoint: 'sobec/one-off-transitions/registration-numbers',
            editItem: {
                route: null,
                routeParameterValue: 'id'
            },
            deleteItem: {
                vuexAction: 'DELETE_REGISTRATION_NUMBER',
                replaceStrWithColumnValue: 'registration_number',
                confirmationText : 'Ste prepričani, da želite odstraniti registrsko številko {str_to_replace} ?',
                dialogConfirmSuccessText: 'Registrska številka {str_to_replace} je bila uspešno odstranjena.',
                dialogConfirmFailText: 'Pri brisanju registrske številke {str_to_replace} je prišlo do napake. Poskusite ponovno.'
            },

            toolbar: {
                buttons: {
                    refresh: true,
                    export: false,
                    addNew: false,
                    addNewRoute: '',
                    toggleColumns: true
                }
            },

            eventBus: {
                refreshDataTable: 'refresh_dt_registration_numbers',
                totalItems : {
                    event: ''
                },
                search: 'dt-registration-numbers-search',
                toggleColumnsId: 'toggle-events-list-columns'
            }


        }
    }),

    watch: {
        registration_number(value) {
            if(value != null) {
                //window.console.log(this.registration_number_1)
                this.registration_number = this.registration_number.replace(/[^a-zA-Z0-9]/g, "");
                this.registration_number = this.registration_number.toUpperCase();
            }
        },

        restriction_start_date (val) {
            this.restriction_start_date_formatted = formatDate(val)
        },

        restriction_end_date (val) {
            this.restriction_end_date_formatted = formatDate(val)
        },

        restriction_start_date_formatted(val) {
            if(val == null) {
                this.restriction_start_date = null
            }
        },

        restriction_end_date_formatted(val) {
            if(val == null) {
                this.restriction_end_date = null
            }
        },
    },

    computed: {
        columnBinding() {
            const binding = {}

            if (this.$vuetify.breakpoint.mdAndDown) binding.column = true

            return binding
        },

        queryParameters() {
            return {
                startDate: this.restriction_start_date,
                endDate: this.restriction_end_date,
                startTime: this.start_time,
                endTime: this.end_time,
                registrationNumber: this.registration_number,
                selectedCompanies: this.selected_companies.map(item => item.id),
                used: this.used,
                expired: this.expired,
                valid_validations: this.valid_validations
            }
        },
        

        btnSubmitFormTitle() {
            if(this.$vuetify.breakpoint.smAndDown) {
                return 'Shrani'
            }

            return 'Validiraj registrsko številko'
        },

        apiMessages() {
            return this.backendMessages;
        },

        apiErrorMessages() {
            return this.backendErrorMessages 
        },

        apiValidationMessages() {
            return this.backendValidationMessages
        },

        checkboxExpiredOnlyLabel() {
            if(this.expired) {
                return 'DA'
            }

            return 'NE'
        },


        checkboxUsedOnlyLabel() {
            if(this.used) {
                return 'DA'
            }

            return 'NE'
        },

        checkboxValidOnlyLabel() {
            if(this.valid_validations) {
                return 'DA'
            }

            return 'NE'
        }
    },

    methods: {
        startDateMenuSave(value) {
            this.$refs.start_date_menu.save(value)
            this.start_date_menu = false
        },

        endDateMenuSave(value) {
            this.$refs.end_date_menu.save(value)
            this.end_date_menu = false
        },

        checkApplicationPermissions(requiredPermissions) {
            return checkPermissions(requiredPermissions, getUserApplicationPermissions())
        },

        search() {
            EventBus.$emit(this.dataTableSettings.eventBus.refreshDataTable, 'pass-some-data');
        },

        exportData() {
            window.console.log("exporting data ...");
            let parameters = {
                startDate: this.restriction_start_date,
                endDate: this.restriction_end_date,
                startTime: this.start_time,
                endTime: this.end_time,
                registrationNumber: this.registration_number,
                selectedCompanies: this.selected_companies.map(item => item.id),
                used: this.used,
                expired: this.expired,
                valid_validations: this.valid_validations
            }
            
            addExportToQueue('registration-numbers', parameters);
        },

        clearRegistrationNumber() {
            this.registration_number = null
        },

        submitForm() {
            var vm = this
            if(this.$refs.form.validate()) {

                this.backendValidationMessages = []
                this.backendMessages = []
                this.backendErrorMessages = []

                if(vm.restriction_start_date == null || vm.restriction_start_date == "") {
                    vm.restriction_start_date = vm.currentDate
                }

                if(vm.restriction_end_date == null || vm.restriction_end_date == "") {
                    vm.restriction_end_date = vm.currentDate
                }
                
                let regNum = vm.registration_number

                vm.$store.commit('SET_PROGRESS', true)
                vm.storeUserLoading = true
                vm.$store.commit('SET_LOADER_TEXT', 'Validiranje registrske številke ' + vm.registration_number + ' je v teku...')
                vm.$store.commit('SET_LOADER', true)
                vm.$store.dispatch('ADD_REGISTRATION_NUMBER', {
                    registration_number: vm.registration_number,
                    restriction_start_date: vm.restriction_start_date,
                    restriction_end_date: vm.restriction_end_date
                })
                .then(response => {
                    //window.console.log(response)
                    vm.$store.commit('snackbarDisplay', false)
                    vm.$store.commit('snackbarText', "Registrska številka " + vm.registration_number + " je uspešno validirana.")
                    vm.$store.commit('snackbarMode', '')
                    vm.$store.commit('snackbarTimeout', 7000)
                    vm.$store.commit('snackbarDisplay', true)

                    vm.clearForm()

                    vm.backendMessages.push('Registrska številka ' + regNum + 'je uspešno validirana.');
                    

                })
                .catch(error => {
                    console.log('ADD_REGISTRATION_NUMBER error')
                    console.log(error)
                    vm.$store.commit('snackbarDisplay', false)
                    vm.$store.commit('snackbarMode', 'multi-line')
                    vm.$store.commit('snackbarText', 'Pri validiranju registrske številke ' + vm.registration_number + ' je prišlo do napake. Prosimo poskusite ponovno.')
                    vm.$store.commit('snackbarDisplay', true)

                    if(error.response.status === 422) {
                        window.console.log(error.response.data.errors)
                        for (const property in error.response.data.errors) {
                            //window.console.log(`${property}: ${error.response.data.errors[property]}`);
                            var propertyData = error.response.data.errors[property];
                            //window.console.log(propertyData);
                            propertyData.forEach(message => {
                                vm.backendValidationMessages.push(message);
                            })

                            setTimeout(() => {
                                vm.$vuetify.goTo('#form_card', {
                                    duration: 1000,
                                    offset: 0,
                                    easing: 'easeInOutCubic'
                                })
                            }, 200)
                        }
                    } else {
                        vm.backendErrorMessages.push('Ups... pri validiranju registrske številke ' + vm.registration_number + ' je prišlo do napake. Poskusite ponovno.')
                        setTimeout(() => {
                            vm.$vuetify.goTo('#form_card', {
                                duration: 1000,
                                offset: 0,
                                easing: 'easeInOutCubic'
                            })
                        }, 200)
                    }

                })
                .finally(() => {
                    setTimeout(() =>{
                        vm.storeUserLoading = false;
                        vm.$store.commit('SET_PROGRESS', false)
                        vm.$store.commit('SET_LOADER', false)
                        vm.$store.commit('SET_LOADER_TEXT', '')
                        EventBus.$emit(vm.dataTableSettings.eventBus.refreshDataTable, null)
                    },600)
                })

            }
            else
            {
                setTimeout(() => {
                    vm.$vuetify.goTo('#form_card', {
                        duration: 1000,
                        offset: 0,
                        easing: 'easeInOutCubic'
                    })
                }, 200)
            } 
        },

        clearBackendMessages() {
            this.backendValidationMessages = []
            this.backendMessages = []
            this.backendErrorMessages = []
        },

        clearForm() {
            this.$refs.form.resetValidation();
            this.setDefaultFormValues()
            this.clearBackendMessages()
        },

        setDefaultFormValues() {
            this.registration_number = null,
            this.restriction_start_date = this.currentDate
            this.restriction_end_date = this.currentDate
        },

        displayResults() {
            setTimeout(() => {
                EventBus.$emit(this.dataTableSettings.eventBus.refreshDataTable, 'pass-some-data');
            }, 280)
        }
    },
        

    created() {
        this.$store.dispatch('ROUTE_NAME', this.$route.name) 
        this.currentDate = getCurrentDate()

        this.restriction_start_date = getCurrentDate()
        this.restriction_end_date = getCurrentDate()
        this.start_time = "00:01"
        //this.endTime = getCurrentTime()
        this.end_time = "23:59";

        this.refreshCompaniesInterval = setInterval(() => {
            this.companies = this.$store.getters.companies
        }, 3000);

        if(isMobileDevice(this)) {
            this.card1 = false
        }
    },

    mounted() {
        this.restriction_start_date = this.currentDate
        this.restriction_end_date = this.currentDate
    },

    beforeDestroy() {
        clearInterval(this.refreshCompaniesInterval)
    }
}

</script>

<style scoped>

</style>